// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification-bar_notification__2I3HH","check":"notification-bar_check__3ATWs"};